import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { showOptionalTermsOfUse } from '../actions/termsOfUse';

const TermsOfUseLink = () => {
    const dispatch = useDispatch();
    const languageStrings = useSelector((state) => state.language.strings);
    const onClick = () => dispatch(showOptionalTermsOfUse())

    return (
        <div className='pb-2 pt-2'>
            <span>
                {languageStrings.TERMS_OF_USE_SIDE_LINK_1}
                <i>
                    <a href="#" onClick={onClick}>
                        {languageStrings.TERMS_OF_USE_SIDE_LINK_2}
                    </a>
                </i>
                {languageStrings.TERMS_OF_USE_SIDE_LINK_3}
            </span>
        </div>
    )
};

export default TermsOfUseLink;
